import { useEffect, useRef } from 'react'

const MODAL_BACK_MANAGER_KEY = '__heliosModalBackManager'

const getModalBackManager = () => {
    if (!window[MODAL_BACK_MANAGER_KEY]) {
        window[MODAL_BACK_MANAGER_KEY] = { depth: 0, ignoreNextPop: false }
    }
    return window[MODAL_BACK_MANAGER_KEY]
}

export function useModalBackButton(isOpen, onClose) {
    const hasHistoryEntry = useRef(false)
    const closedFromBack = useRef(false)
    const registeredInManager = useRef(false)
    const onCloseRef = useRef(onClose)

    useEffect(() => {
        onCloseRef.current = onClose
    }, [onClose])

    useEffect(() => {
        if (!isOpen) return

        const manager = getModalBackManager()
        closedFromBack.current = false
        registeredInManager.current = true
        manager.depth += 1
        window.history.pushState({ modalOpen: true }, '')
        hasHistoryEntry.current = true

        const handlePop = (event) => {
            if (!hasHistoryEntry.current) return

            hasHistoryEntry.current = false
            closedFromBack.current = true

            if (registeredInManager.current) {
                registeredInManager.current = false
                manager.depth = Math.max(manager.depth - 1, 0)
            }

            // This pop belongs to top-most modal; don't let parent handlers run.
            event.stopImmediatePropagation()
            onCloseRef.current?.()
        }

        window.addEventListener('popstate', handlePop, true)

        return () => {
            window.removeEventListener('popstate', handlePop, true)

            if (registeredInManager.current) {
                registeredInManager.current = false
                manager.depth = Math.max(manager.depth - 1, 0)
            }

            if (hasHistoryEntry.current && !closedFromBack.current) {
                hasHistoryEntry.current = false
                manager.ignoreNextPop = true
                window.history.back()
            }
        }
    }, [isOpen])
}
